import Amex from '@images/payment/creditCard/amex.svg'
import Discover from '@images/payment/creditCard/discover.svg'
import Maestro from '@images/payment/creditCard/maestro.svg'
import MasterCard from '@images/payment/creditCard/mastercard.svg'
import Visa from '@images/payment/creditCard/visa.svg'

export const CREDIT_CARDS = {
  VISA: 'Visa',
  MASTERCARD: 'Mastercard',
  MAESTRO: 'Maestro',
  AMEX: 'Amex',
  DISCOVER: 'Discover'
} as const

export type CreditCardType = (typeof CREDIT_CARDS)[keyof typeof CREDIT_CARDS]

const { VISA, MASTERCARD, MAESTRO, AMEX, DISCOVER } = CREDIT_CARDS

export const cards = [
  {
    name: VISA,
    prefixNumber: /^4/,
    cvvLength: 3,
    image: Visa
  },
  {
    name: MASTERCARD,
    prefixNumber: /^(222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720|5[1-5])/,
    cvvLength: 3,
    image: MasterCard
  },
  {
    name: MAESTRO,
    prefixNumber:
      /^(5018|5020|5038|5893|6304|6759|6761|6762|6763|6759|676770|676774)/,
    cvvLength: 3,
    image: Maestro
  },
  {
    name: AMEX,
    prefixNumber: /^(34|37)/,
    cvvLength: 4,
    image: Amex
  },
  {
    name: DISCOVER,
    prefixNumber:
      /^(62212[6-9]|6221[3-9]\d|622[2-8]\d{2}|6229[01]\d|62292[0-5]|6011|644|645|646|647|648|649|65)/,
    cvvLength: 3,
    image: Discover
  }
]
